import { Button, ButtonProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Row } from "v2/components/base/Flex/ui";

const CircleButtonUI = (props: ButtonProps) => {
  const theme = useTheme();
  const { sx, ...rest } = props;

  return (
    <Button
      sx={{
        minWidth: "fit-content",
        width: "fit-content",
        padding: "14.5px 20px",
        borderRadius: "20px",
        backgroundColor: theme.palette.surface.light,
        color: theme.palette.text["btn-dark"],
        "&:hover": {
          backgroundColor: theme.palette.surface.light,
          filter: "brightness(0.9)",
        },
        ...sx,
      }}
      {...rest}>
      {/* <Row type="cc" fullHeight> */}
      {props.children}
      {/* </Row> */}
    </Button>
  );
};

export default CircleButtonUI;
